<template>
  <div>
    <div v-if="!isShow" class="loading">
      <van-loading size="32px">加载中...</van-loading>
    </div>
    <div v-if="isShow">
      <div class='title'>请选择医院</div>
      <div v-for="(item, index) in list" :key="index" class="list-item" @click="goInfo(item)">
        <div>{{ item.name }}</div>
      </div>
      <div class="list-item" v-if="showNo">
        <div>没有医院数据</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      isShow: 0,
      showNo: 0,
      openId: '',
      type: '',
      list: [],
      topicId: '',
      topicGroupId: '',
    };
  },
  mounted() {
    this.openId = this.$route.query.openId;
    this.type = this.$route.query.type ? this.$route.query.type : '';
    this.topicId = this.$route.query.topicId;
    this.topicGroupId = this.$route.query.topicGroupId;
    document.title = '选择医院';
    this.getList();
  },
  methods: {
    /**
     * 获取医院列表
    */
    async getList() {
      let auth = this.$createAuth(this.$md5);
      let result = await this.$http.get(this.$url.getHospital, {
        openId: this.openId,
        auth: auth.code,
        time: auth.time
      });

      if (result.message === 'Error: Miss auth parameter.') {
        this.getList();
      } else {
        this.list = result.data.hospitals;
        this.isShow = 1;
        if (this.list.length == 0) {
          this.showNo = 1;
        }
        if (this.list.length == 1) {
          let item = this.list[0];
          this.goInfo(item);
        }
      }
    },
    /**
     * 跳转登记页面
    */
    goInfo(item) {
      let url = `/ysgInfo?openId=${this.openId}&hospitalId=${item.id}&type=${this.type}`;
      if (this.topicId) url += `&topicId=${this.topicId}`;
      if (this.topicGroupId) url += `&topicGroupId=${this.topicGroupId}`;
      this.$router.push(url);
    }
  }
};
</script>
<style scope lang="less">
.loading {
  margin-top: 40vh;
  font-size: 0.32rem;
}

.title {
  padding: 0.3rem 0;
  font-size: 0.36rem;
  background: #f2f2f2;
}

.list-item {
  padding: 0.3rem 0;
  border-bottom: 1px solid #eee;
}
</style>
